import { memo } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { NavLink } from "react-router-dom"
import Tooltip from "components/material/tooltip"
import BetaTag from "./beta-tag"

Content.propTypes = {
  MaterialIcon: PropTypes.object.isRequired,
  label: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  showBetaTag: PropTypes.bool,
}

function Content({ label, MaterialIcon, disabled, showBetaTag }) {
  return <>
    <MaterialIcon className="material-menu-icon" {...(disabled && { color: "disabled" })} />
    <span className="label">{label}</span>
    {showBetaTag && <BetaTag />}
  </>
}

function NavRailItem({ label, to, external, MaterialIcon, onClick, className, disabled, disabledTooltip, showBetaTag, ref }) {
  const classes = classNames("item", className, { disabled, "has-beta-tag": showBetaTag })

  if (!to) {
    return <div className={classes} onClick={onClick} ref={ref}>
      <Content {...{ label, MaterialIcon, showBetaTag }} />
    </div>
  }

  if (external) {
    return <a className={classes} href={to} tabIndex={-1} target="_blank" rel="noreferrer noopener" ref={ref}>
      <Content {...{ label, MaterialIcon, showBetaTag }} />
    </a>
  }

  // Rail routes are account-absolute; the account is the first path segment.
  const [, accountSegment] = window.location.pathname.split("/")
  const accountAbsoluteTo = `/${accountSegment}/${to}`
  const content = <Content {...{ label, MaterialIcon, disabled, showBetaTag }} />

  if (disabled) {
    return <Tooltip title={disabledTooltip}>
      <div className={classes} ref={ref}>
        {content}
      </div>
    </Tooltip>
  }

  return <NavLink className={({ isActive }) => classNames(classes, { active: isActive })} to={accountAbsoluteTo} tabIndex={-1} onClick={onClick} ref={ref}>
    {content}
  </NavLink>
}

NavRailItem.propTypes = {
  MaterialIcon: PropTypes.object.isRequired,
  label: PropTypes.node.isRequired,
  to: PropTypes.string,
  onClick: PropTypes.func,
  external: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  disabledTooltip: PropTypes.string,
  showBetaTag: PropTypes.bool,
  // Forwarded to the rendered root so callers can anchor popovers to the item.
  ref: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
}

// Memoized so the rail's stable per-item handlers actually avoid work: every prop the rail passes
// is a module constant or a referentially stable callback, so items skip the rail's own re-renders.
export default memo(NavRailItem)
